import { render, staticRenderFns } from "./GraficoEstatura.vue?vue&type=template&id=beaf1466&scoped=true"
import script from "./GraficoEstatura.vue?vue&type=script&lang=js"
export * from "./GraficoEstatura.vue?vue&type=script&lang=js"
import style0 from "./GraficoEstatura.vue?vue&type=style&index=0&id=beaf1466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf1466",
  null
  
)

export default component.exports